import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BreadcrumbService } from 'xng-breadcrumb';
import { SubHeaderService } from '../../../../../shared/store/subheader/subheader.service';
import { View } from '../../../../../shared/store/view/types';
import { ViewService } from '../../../../../shared/store/view/views.service';
import { WorkScheduleService } from '../../../../../shared/store/attendance/work-schedule/work-schedule.service';
import { WorkScheduleModel } from '../../../../../shared/store/attendance/work-schedule/types';

@UntilDestroy()
@Component({
  selector: 'app-work-schedule-details',
  standalone: false,
  templateUrl: './work-schedule-details.component.html',
  styleUrl: './work-schedule-details.component.scss',
})
export class WorkScheduleDetailsComponent implements OnInit, OnDestroy {
  workScheduleId: number;
  workSchedule$: Observable<WorkScheduleModel>;
  view$: Observable<View>;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly workScheduleService: WorkScheduleService,
    private readonly subHeaderService: SubHeaderService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService,
  ) {
    this.workSchedule$ = this.workScheduleService.getById.value$;
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    this.workScheduleId = this.route.snapshot.params['id'];
    this.workScheduleService.getById.call(this.workScheduleId);

    this.workSchedule$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@workScheduleDetails', x.name);
      });

    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@list', x.title);
      });

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'workScheduleEdit') {
          this.router.navigate([
            '/Configuration/WorkSchedules/Edit',
            this.workScheduleId,
          ]);
        }
        this.subHeaderService.setTriggerAction('');
      });
  }

  ngOnDestroy(): void {
    this.workScheduleService.getById.reset();
    this.breadcrumbService.set('@workScheduleDetails', ' ');
  }
}
